export enum MapInteractionMode {
    DEFAULT,
    THEMATIC_MAP_ACTIVE,
    INTERACTION_DATASET_ACTIVE
}
